export const endPoints = {
  CONTRACT: '/v1/contract',
  CONTRACT_FILTER: '/v1/contract/filter',
  CONTRACT_FILTER_EXCEL: '/v1/contract/filter/excel',
  CONTRACT_FILTER_EXCEL_SUMMARY: '/v1/contract/filter/excel/summary/v2',
  CONTRACT_TRANSFER: '/v1/contract/transfer',
  DRAFT_EXCEL: "/v1/contract/draft/excel"
};
